































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import OfferListAlertBar from './OfferListAlertBar'
import UiList from '@superUI/List/List'

settings = 
  name: ""
  resources: 
    offers: 
      infinityScroll: true
      resourceName: "offer"
      slug: "offers"
      params:
        scope: ":scope"
  vue: 
    components: { LoadingIndicator, OfferListAlertBar, UiList }
    computed:
      offerTitlePrefix: ->
        return 'All' unless @$route.query.scope?
        return @$route.query.scope
    methods: 
      statusTagClassForOffer: (offer) -> 
        switch offer.state
          when 'accepted' then 'bg-success'
          when 'denied' then 'bg-red'
          when 'draft' then 'bg-draft'
          else 'bg-recess'
      refreshOfferList: -> @fetchInfinity(null, 'offers', {}, { page : 1})
    watch:
      $route: ->
        window.stop()
        @clearDataForResourceKey('offers')
        @refreshOfferList()
export default VueOptions.vue settings
